<div class="myspinner">   
    <i class="fa fa-minus myminus" (click)="minusClicked()"></i>
    <input disabled class="myinput" type="text" value='{{counter}}'>
    <i class="fa fa-plus myplus" (click)="plusClicked()"></i>
</div>